import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./LoginPage.module.css";
import { useAuth } from "../contexts/AuthContext";
import Button from "components/common/Button";
import { Helmet } from "react-helmet";

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [errors, setErrors] = useState({});

  const { register } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const from = location.state?.from || "/confirmation";


  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await register({
      email,
      password,
      confirmPassword,
      firstname,
      lastname,
      phone,
    });

    if (!response.success) {
      setErrors(response.errors.errors);
    } else {
      setErrors({});
      navigate(from, { replace: true });
    }
    console.log(response);

  };

  return (
    <div className="page-content">
      <Helmet>
        <title>Inscription - Pharos</title>
        <meta name="description" content="Inscrivez-vous sur Pharos pour accéder à tous nos spectacles et gérer vos réservations." />
        <meta property="og:title" content="Inscription - Pharos" />
        <meta property="og:description" content="Inscrivez-vous sur Pharos pour accéder à tous nos spectacles et gérer vos réservations." />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className={`global-section ${styles.section}`}>
        <div className={`global-container ${styles.content}`}>
          <div className={styles.loginContainer}>
            <div className={styles.formContainer}>
              <h1 className="h2">S’inscrire</h1>
              <p className={styles.Description}>Inscrivez-vous en quelques clics.</p>
              <form onSubmit={handleSubmit}>
                <ul className={styles.InputsList}>
                  <li>
                    <label htmlFor="username">Email (identifiant)*</label>
                    <input
                      type="text"
                      name="email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      aria-required="true"
                    />
                    {errors.email && <span className={styles.error}>{errors.email}</span>}
                  </li>
                  <li>
                    <label htmlFor="username">Mot de passe*
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      aria-required="true"
                    />
                    {errors.password && <span className={styles.error}>{errors.password}</span>}
                  </li>
                  <li>
                    <label htmlFor="confirm-password">Confirmer mot de passe*
                    </label>
                    <input
                      type="password"
                      name="confirm-password"
                      value={confirmPassword}
                      onChange={e => setConfirmPassword(e.target.value)}
                      aria-required="true"
                    />
                    {errors.confirmPassword && <span className={styles.error}>{errors.confirmPassword}</span>}
                  </li>
                  <li className={styles.rowSplit}>
                    <label htmlFor="firstname">Prénom*
                    </label>
                    <input
                      type="text"
                      name="firstname"
                      value={firstname}
                      onChange={e => setFirstname(e.target.value)}
                      aria-required="true"
                    />
                    {errors.firstname && <span className={styles.error}>{errors.firstname}</span>}
                  </li>
                  <li className={styles.rowSplit}>
                    <label htmlFor="lastname">Nom*
                    </label>
                    <input
                      type="text"
                      name="lastname"
                      value={lastname}
                      onChange={e => setLastname(e.target.value)}
                      aria-required="true"
                    />
                    {errors.lastname && <span className={styles.error}>{errors.lastname}</span>}
                  </li>
                  <li>
                    <label htmlFor="phone">Téléphone*
                    </label>
                    <input
                      type="text"
                      name="phone"
                      value={phone}
                      onChange={e => setPhone(e.target.value)}
                      aria-required="true"
                    />
                    {errors.phone && <span className={styles.error}>{errors.phone}</span>}
                  </li>
                </ul>

                <Button type="submit">S’enregistrer</Button>
              </form>
            </div>
            <div className={styles.image}>
              <img src={`/images/ready-for-the-show.webp`} alt="" aria-hidden="true"></img>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegisterPage;
